const usePortalSubscription = () => true;

export default usePortalSubscription;
